export const posdevice = {
  seo: {
    title: 'Bistroo Device pour restaurants de vente à emporter & livraison',
    description: "Le Bistroo Device est idéal pour la vente à emporter et la livraison, entièrement intégré à votre boutique en ligne, commande QR ou borne de commande.",
  },
  hero: {
    title: {
      pt1: 'Un',
      pt2: 'Bistroo Device',
      pt3: 'prêt à l\'emploi pour les commandes en ligne',
    },
    description:
      'Le seul appareil dont vous avez besoin pour traiter les commandes. Recevoir, gérer et imprimer. Tout depuis un seul appareil portable.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plug & play, serve all day',
      text: 'Aucune installation complexe ni connaissance technique requise. Allumez simplement l\'appareil et commencez immédiatement. Commencez à accepter votre première commande en quelques minutes.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Gérer, confirmer et imprimer les commandes',
      text: 'Traitez les commandes sans effort depuis l\'appareil, confirmez en un clic et communiquez manuellement le délai d\'enlèvement ou de livraison prévu. Effectuez facilement un remboursement à tout moment. Pas d\'imprimante supplémentaire nécessaire, tout est intégré.',
      cta: '',
    },
    paragraph_3: {
      title: 'Mettez à jour votre boutique à tout moment',
      text: 'Fermez facilement des créneaux horaires de dernière minute, mettez temporairement des produits en inactif et imprimez rapidement votre aperçu du chiffre d\'affaires (journalier). Tout à portée de main, exactement quand vous en avez besoin.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Pas de câbles, pas de chaos',
      text: 'Entièrement sans fil avec une longue autonomie de batterie, sans encombrement de câbles sur votre sol de cuisine. En intérieur ou extérieur, avec WiFi et 4G, vous pouvez accepter des commandes partout. Vous êtes toujours en ligne.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Gestion des commandes.',
        text: 'Gérez vos commandes en temps réel et gardez facilement une vue d\'ensemble de tous les processus.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Sachez ce que vous gagnez.',
        text: 'Consultez votre chiffre d\'affaires pour une période donnée en un simple clic.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Le temps est entre vos mains.',
        text: 'Gérez vos créneaux horaires sans effort pour éviter les goulots d\'étranglement en cuisine et optimiser votre flux de travail.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'En rupture de stock, pas de problème.',
        text: 'Gérez votre inventaire de produits en temps réel en un seul clic.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Paramètres de distribution.',
        text: 'Modifiez vos paramètres de distribution en temps réel et adaptez-les rapidement.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo pense avec nous à des solutions et de nouvelles opportunités."',
    cta: 'Lire l\'histoire complète',
    name: 'Il Municipio',
    job_title: 'Restaurant Italien',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'Bistroo Device',
    items: [
      { q: 'Qu\'est-ce que le Bistroo Device ?', a: 'Le Bistroo Device est un terminal portable compact qui vous permet de recevoir, gérer et imprimer les commandes. C\'est le seul appareil dont vous avez besoin pour traiter entièrement vos commandes en ligne.' },
      { q: 'Combien de temps faut-il pour démarrer avec le Bistroo Device ?', a: 'L\'appareil est plug-and-play : allumez-le, connectez-le au Wi-Fi et vous recevez immédiatement des commandes. Aucun installateur nécessaire, aucune connaissance technique requise.' },
      { q: 'Le Bistroo Device dispose-t-il d\'une imprimante intégrée ?', a: 'Oui. L\'imprimante est intégrée dans l\'appareil. Vous n\'avez pas besoin de connecter une imprimante séparée. Chaque commande imprime directement le ticket souhaité pour la cuisine ou le client.' },
      { q: 'Puis-je utiliser l\'appareil à l\'extérieur ou en déplacement ?', a: 'Oui. L\'appareil fonctionne entièrement sans fil via Wi-Fi et 4G. Vous pouvez traiter des commandes en terrasse, lors d\'un événement ou en déplacement, toujours connecté.' },
      { q: 'Quelle est l\'autonomie de la batterie ?', a: 'La batterie est conçue pour une journée de travail complète. Lors des services chargés, nous recommandons de recharger l\'appareil entre-temps via le chargeur fourni.' },
      { q: 'Comment confirmer une commande via l\'appareil ?', a: 'Lorsqu\'une nouvelle commande arrive, elle apparaît immédiatement à l\'écran. En un clic, vous confirmez la commande et communiquez le délai d\'enlèvement ou de livraison prévu au client.' },
      { q: 'Puis-je gérer les créneaux horaires et les stocks de produits via l\'appareil ?', a: 'Oui. Via l\'appareil, vous fermez rapidement des créneaux, désactivez temporairement des produits et adaptez votre offre en temps réel. Pratique si un plat est épuisé ou si la cuisine ne peut pas l\'honorer momentanément.' },
      { q: 'Le Bistroo Device peut-il être connecté à ma boutique et à ma borne ?', a: 'Oui. L\'appareil reçoit les commandes de tous les canaux Bistroo : votre boutique en ligne, votre borne, la commande QR à table et le service de commande Bistroo. Tout sur un seul appareil.' },
      { q: 'Comment traiter les remboursements via l\'appareil ?', a: 'Dans l\'aperçu des commandes sur l\'appareil, sélectionnez la commande et choisissez Remboursement. Le montant est immédiatement recrédité sur le compte du client.' },
      { q: 'Quel est le coût du Bistroo Device ?', a: 'L\'appareil est disponible en location ou à l\'achat, combiné à une formule logicielle Bistroo. Contactez-nous via bistroo.nl pour un devis actualisé personnalisé.' },
    ],
  },
}
